import React, {useState, useEffect} from 'react';
import {getGetPosts} from '../../services/servicesGetPosts';
import {Link, useLocation, useHistory} from 'react-router-dom';
import {DivImage,Image,DivBusca} from './styleBusca'
import {URLIMG} from '../../helpers/constantes';
import ButtonTrialVersion from '../../components/ButtonTrialVersion/ButtonTrialVersion';
import Toastify from '../../components/Toastify/index';
export default function Busca(){

    const location = useLocation();
    const history = useHistory();
    const [postsFiltrados, setPostsFiltrados] = useState([])
    const [pegaPalavraDaBusca, setPegaPalavraDaBusca] = useState(window.location.href.split('/'));

    async function carregaMyPosts(string){
        const resultBuscaPosts = await getGetPosts(string);
        if(resultBuscaPosts.status === 200)
        setPostsFiltrados(resultBuscaPosts.data);
        else {
            Toastify.error('Erro ao realizar a busca.');
        }
    }
    function redirectURL({pathname, state}){
        history.push(pathname)
        location.pathname = pathname
    }
    //para a primeira vez que entra na pagina
    useEffect(()=>{
        carregaMyPosts(pegaPalavraDaBusca[pegaPalavraDaBusca.length - 1]);
        // filtro(postsFiltrados,myposts);

    },[]);
//para ficar verificando se a pagina recebeu uma nova busca
    useEffect(() => {
        const newId = window.location.href.split('/');
        setPegaPalavraDaBusca(newId[newId.length - 1]);
        carregaMyPosts(newId[newId.length - 1]);
        // filtro(postsFiltrados,myposts);
    }, [window.location.href]);

return(<div style={{height:'calc(100% - 60px)', overflow:'hidden auto',padding:'20px'}}>
        <ButtonTrialVersion />
    <h1 style={{margin:'20px',fontFamily:'Ubuntu'}}>
        Resultado para a busca palavra pesquisada:{
            pegaPalavraDaBusca != ''
            ?
             '"'+decodeURIComponent(pegaPalavraDaBusca)+'"'
            :''
        }
    </h1>
    <DivBusca>
    {postsFiltrados.map(item=>{
        return(<DivImage key={item.Id} onClick={()=> redirectURL({pathname:`/app/postedit/${item.Id}`})} >
                <Image
                    src={`${URLIMG+item.Image1.split('/')[item.Image1.split('/').length - 1]}`}
                />
        </DivImage>)
    })}
    </DivBusca>
</div>)
}
